import { makeStyles } from "@mui/styles";
import { BRAND } from "../../utils/constants/colors";

export const styles = makeStyles({
  hovering: {
    textDecoration: "none",
    "& :hover": {
      color: BRAND.PRIMARY,
    },
  },
  Padding: {
    paddingLeft: "5px",
    paddingRight: "5px",
  },
});
